import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';

import { AboutComponent } from './_components/about/about.component';
import { ServicesComponent } from './_components/services/services.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';
import { BrandsComponent } from './_components/brands/brands.component';
import { ServiceprovidertypesComponent } from './_components/serviceprovidertypes/serviceprovidertypes.component';
import { LocationsComponent } from './_components/locations/locations.component';
import { LoginComponent } from './_components/login/login.component';
import { LogoutComponent } from './_components/logout/logout.component';
import { LocationeditComponent } from './_components/locations/locationedit/locationedit.component';
import { EditBrandsComponent } from './_components/brands/edit-brands/edit-brands.component';
import { EditserviceprovidertypeComponent } from './_components/serviceprovidertypes/editserviceprovidertype/editserviceprovidertype.component';
import { ImageprocessComponent } from './_components/imageprocess/imageprocess.component';
import { RouteLocationComponent } from './_components/locations/route-location/route-location.component';

export const router: Routes = [
   // { path: '', redirectTo: 'about', pathMatch: 'full' },
    { path: '', component: LoginComponent},
    { path: 'login', component: LoginComponent},
    { path: 'about', component: AboutComponent},
    { path: 'services', component:ServicesComponent},
    { path: 'dashboard', component:DashboardComponent},
    { path: 'serviceprovidertypes', component:ServiceprovidertypesComponent},
    { path: 'serviceprovidertypes/edit/:id', component:EditserviceprovidertypeComponent},
    { path: 'locations', component:LocationsComponent},
    { path: 'locations/edit/:id', component:LocationeditComponent},
    { path: 'locations/edit', redirectTo: 'locations'},
    { path: 'brands', component:BrandsComponent},
    { path: 'brands/edit', redirectTo: 'brands'},
    { path: 'brands/edit/:id', component:EditBrandsComponent},
    { path: 'logout', component:LogoutComponent},
    { path: 'imageprocess',component:ImageprocessComponent },
    { path: 'routelocation',component:RouteLocationComponent}
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router, {useHash: true});



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/app.router.ts